export const initialState = () => ({
	widget: null,
	widgetId: null,
	editField: null,
	widgetTitle: null,
	widgetMetadata: null,
	isSavingWidget: false,
	isLoadingWidgetFields: false,
	saveWidgetPromise: null,
	workflowVersionId: null,
});

export const getState = () => initialState();
